import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledSplitPanelBody,
  Icon,
  Header,
  Body,
  SocialMediaIcons,
} from './styles.js';

export const SplitPanelBody = ({ heading, icon, body, socialMediaIcons }) => {
  return (
    <StyledSplitPanelBody>
      {icon && <Icon alt={icon.alt} src={icon.src} />}
      {heading && <Header>{heading}</Header>}
      <Body>{body}</Body>
      {socialMediaIcons && (
        <SocialMediaIcons>
          {socialMediaIcons.map((SMIcon, i) => (
            <a key={i} href={SMIcon.url} rel="noreferrer" target="_blank">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img alt={SMIcon.alt} src={SMIcon.src} />
            </a>
          ))}
        </SocialMediaIcons>
      )}
    </StyledSplitPanelBody>
  );
};

SplitPanelBody.displayName = 'SplitPanelBody';

SplitPanelBody.propTypes = {
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  }),
  heading: PropTypes.string,
  body: PropTypes.node,
  socialMediaIcons: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
};
